import React from 'react'

import type { ListCustomerProps } from './ListCustomer.native'

//@ts-ignore
import _ListCustomer from './ListCustomer'

export type { ListCustomerProps } from './ListCustomer.native'
export { LIST_CUSTOMER_H } from './ListCustomerContent'

const ListCustomer = _ListCustomer as React.MemoExoticComponent<
  React.FC<ListCustomerProps>
>

export default ListCustomer
